import { Observable } from 'rxjs'
import { environment } from '@exchange/environment'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'

@Injectable()
export class PayerDocumentService {
  constructor(private httpClient: HttpClient) {}

  fetchDocument(payerId: string, filename: string): Observable<Blob> {
    const url = `${environment.blobapiroot}/payermedia/${payerId}/${filename}`
    const options = {
      responseType: 'arraybuffer' as const,
      observe: 'response' as const
    }

    return this.httpClient.get(url, options).pipe(
      map(r => r as HttpResponse<any>),
      map(response => {
        const contentType =
          response.headers.has('Content-Type') && response.headers.get('Content-Type')
        let type = 'application/octet-stream'
        if (contentType && contentType.length) {
          type = contentType[0][0]
        }
        return new Blob([response.body], { type })
      })
    )
  }

  deleteDocument(payerId: string, filename: string): Observable<any> {
    const url = `${environment.blobapiroot}/payermedia/${payerId}/${filename}`
    return this.httpClient.delete(url)
  }
}
